import type React from "react";
import { Construction } from "lucide-react";
import { i18n } from "@frontend/i18n";
import { Button } from "@planta-v2/pds-ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@planta-v2/pds-ui/dialog";

export interface FeatureNotImplementedModalProps {
  readonly isOpen: boolean;

  readonly onClose: () => void;

  readonly title?: string | undefined;

  readonly description?: string | undefined;
}

export function FeatureNotImplementedModal({
  isOpen,
  onClose,
  title,
  description,
}: FeatureNotImplementedModalProps): React.JSX.Element {
  const modalTitle = title ?? i18n.t("common.featureNotImplemented.title");
  const modalDescription =
    description ?? i18n.t("common.featureNotImplemented.description");

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      {/* Width 357px matches the Figma spec for modal dialogs; the flex column
          replaces DialogContent's grid so the button stretches to full width. */}
      <DialogContent
        className="flex w-[357px] flex-col sm:max-w-none"
        closeLabel={i18n.t("common.close")}
      >
        <div className="flex flex-col items-center gap-4 text-center">
          {/* Icon - informational, not error */}
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-muted">
            <Construction className="h-6 w-6 text-muted-foreground" />
          </div>

          <DialogTitle>{modalTitle}</DialogTitle>

          <DialogDescription>{modalDescription}</DialogDescription>
        </div>

        <Button onClick={onClose} variant="outline" className="w-full">
          {i18n.t("common.close")}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
